import React, { Fragment } from 'react';

import { Assignee } from 'api/queries/getTopStartDateChanges.query';

import { AssigneeAvatar } from 'components/common/AssigneeAvatar/AssigneeAvatar';

export const DisplayListOfAvatarsCell = ({
    avatarList,
    maxNumberToDisplay,
}: {
    avatarList: Assignee[];
    maxNumberToDisplay?: number;
}) => {
    if (avatarList.length === 0) return null;
    let listToDisplay = avatarList;
    if (maxNumberToDisplay && listToDisplay.length - maxNumberToDisplay > 0) {
        listToDisplay = listToDisplay.slice(0, maxNumberToDisplay);
    }
    return (
        <>
            {listToDisplay.map((avatar, index) => {
                return <AssigneeAvatar key={avatar.userName ?? index} assignee={avatar} />;
            })}
        </>
    );
};
